"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.semverQuery = exports.isSemverNumber = exports.isSemver = exports.numberToSemver = exports.semverToNumber = void 0;
const semver = __importStar(require("semver"));
const lodash_1 = require("lodash");
const semverToNumber = (version) => {
    if ((0, exports.isSemverNumber)(version))
        return version;
    if (!version)
        version = '0.0.0';
    const normalized = semver.coerce(version);
    if (normalized == null)
        throw new Error(`Unable to parse: ${version}`);
    const { major, minor, patch, prerelease, build } = normalized;
    if (!inclusive(major, 0, 999))
        throw new Error(`Major version out of range: ${major}`);
    if (!inclusive(minor, 0, 999))
        throw new Error(`Minor version out of range: ${minor}`);
    if (!inclusive(patch, 0, 999))
        throw new Error(`Patch version out of range: ${patch}`);
    if (build.length > 0)
        throw new Error(`Build syntax is not supported: ${build}`);
    if (prerelease.length > 0)
        throw new Error(`Prerelease syntax is not supported: ${prerelease}`);
    return normalized.major * 1000 * 1000 + normalized.minor * 1000 + normalized.patch;
};
exports.semverToNumber = semverToNumber;
const numberToSemver = (version) => {
    if (!(0, exports.isSemverNumber)(version))
        throw new Error(`Number cannot be converted to semver: ${version}`);
    const digit = (index) => getDigit(version, index);
    const major = Number.parseInt(`${digit(8)}${digit(7)}${digit(6)}`);
    const minor = Number.parseInt(`${digit(5)}${digit(4)}${digit(3)}`);
    const patch = Number.parseInt(`${digit(2)}${digit(1)}${digit(0)}`);
    return `${major}.${minor}.${patch}`;
};
exports.numberToSemver = numberToSemver;
const isSemver = (version) => {
    return semver.coerce(version) != null;
};
exports.isSemver = isSemver;
const isSemverNumber = (version) => {
    if (version === undefined)
        return true;
    if (!Number.isInteger(version))
        return false;
    if (!inclusive(version, 0, 999999999))
        return false;
    return true;
};
exports.isSemverNumber = isSemverNumber;
const semverQuery = (version) => new semver.Range(version).set.map((set) => set.map((comp) => ({
    value: (0, exports.semverToNumber)(comp.value),
    operator: comp.operator,
})));
exports.semverQuery = semverQuery;
const inclusive = (value, min, max) => value >= min && value <= max;
const DIGIT_COUNT = 9;
const getDigit = (value, index) => {
    if (index < 0 || index >= DIGIT_COUNT)
        throw new Error('Index out of range');
    let string = `${value || 0}`;
    const pad = (0, lodash_1.range)(Math.max(DIGIT_COUNT - string.length, 0))
        .map(() => '0')
        .join('');
    string = `${pad}${string}`;
    const endian = DIGIT_COUNT - 1 - index;
    return endian < string.length ? Number.parseInt(string[endian]) : 0;
};
//# sourceMappingURL=pageflowSemver.js.map